import React, { useEffect, useState, useCallback } from "react";
import { Button, Form } from "react-bootstrap";
import { COLOR_APP, K_LOCAL_STORAGE_SHOP_SETTING_DATA } from "../../constants";
import { useToasts } from 'react-toast-notifications'
import { GET_SETTING_BY_SHOP } from "../../graphql/setting/query";
import { CREATE_SETTING_V2, UPDATE_SETTING_V2 } from "../../graphql/setting/mutation";
import { useLazyQuery, useMutation } from "@apollo/client";
import ReactSwitch from "react-switch";

function SettingOther() {
    // Shop id
    const SHOP_ID = localStorage.getItem("SHOP");

    const { addToast } = useToasts()
    const [createSettingV2, { loading: loadingCreateSetting }] = useMutation(CREATE_SETTING_V2)
    const [updateSettingV2, { loading: loadingUpdateSetting }] = useMutation(UPDATE_SETTING_V2)
    const [flowPaymentFirst, setFlowPaymentFirst] = useState(false);
    const [sCodeStartWithO, setSCodeStartWithO] = useState(false);
    const [sp_cod,setSp_cod] = useState(false);
    const [isData, setIsData] = useState(null);

    //TODO: GraphQL
    const [getSettings, {loading: loadingGetSettings, data: dataGetSettings}] = useLazyQuery(GET_SETTING_BY_SHOP, { fetchPolicy: "cache-and-network"});

    const fetchSettings = useCallback(async () => {
        try {
            if (!SHOP_ID) {
                addToast("ບໍ່ພົບການຮ້ານຄ້າ", {
                    appearance: 'warning',
                    autoDismiss: true,
                })
                return;
            }        
            if (SHOP_ID) {
                await getSettings({
                    variables: {
                        where: {
                            shop: SHOP_ID,
                        },
                        orderBy: "createdAt_ASC"
                    }
                })
            }
        } catch (error) {
            console.log("Error in setting callback", error);
        }
        
    }, [SHOP_ID, getSettings, addToast]);

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    useEffect(() => {
        if (dataGetSettings) {
            setFlowPaymentFirst(dataGetSettings?.settingByShopId?.flowPaymentFirst ?? false);
            setSCodeStartWithO(dataGetSettings?.settingByShopId?.sCodeStartWithO ?? false);
            setSp_cod(dataGetSettings?.settingByShopId?.sp_cod ?? false);
            setIsData(dataGetSettings?.settingByShopId);
        }
        localStorage.setItem(K_LOCAL_STORAGE_SHOP_SETTING_DATA, JSON.stringify(dataGetSettings?.settingByShopId));
    }, [dataGetSettings]);

    const _saveSetting = async () => {
        if (!SHOP_ID) {
            addToast("ບໍ່ພົບການຮ້ານຄ້າ", {
                appearance: 'warning',
                autoDismiss: true,
            })
            return;
        }  
        if (!isData) {
            await createSettingV2({
                variables: {
                    data: {
                        flowPaymentFirst: flowPaymentFirst,
                        sCodeStartWithO: sCodeStartWithO || false,
                        sp_cod: sp_cod || false,
                        shop: SHOP_ID
                    }
                }
            })
            fetchSettings()
            addToast("ສ້າງຕັ້ງຄ່າສໍາເລັດ", {
                appearance: 'success',
                autoDismiss: true,
            })
        } else {
            await updateSettingV2({
                variables: {
                    where: {
                        id: isData.id
                    },
                    data: {
                        flowPaymentFirst: flowPaymentFirst,
                        sCodeStartWithO: sCodeStartWithO || false,
                        sp_cod: sp_cod || false,
                        shop: SHOP_ID
                    }
                }
            })
            fetchSettings()
            addToast("ອັບເດດຕັ້ງຄ່າສໍາເລັດ", {
                appearance: 'success',
                autoDismiss: true,
            })
        }
    }

    return (
        <div>
            {loadingGetSettings ? <div>ກຳລັງໂຫຼດ...</div> : (
                <>
                    <div style={{ padding: 20, paddingBottom: 0, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
                        {/* //TODO Setting Auto Reply Order Confirm */}
                        <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> ຕັ້ງຄ່າການ payment ອໍໂຕ ສຳລັບ ເຊວເພສ <span role="img" aria-label="auto-receive">💵💵</span></h5>
                        <div className="row">
                            <div className="col-6">
                                
                                <Form.Group style={{ display: "flex", flexDirection: 'column' }}>
                                    <h7 style={{ fontWeight: 'bold' }}>ໃຊ້ງານ: <span style={{ fontWeight: 'normal', color: flowPaymentFirst ? "green" : "red" }}>{flowPaymentFirst ? "ເປີດ" : "ປີດ"}</span></h7>
                                    <ReactSwitch
                                        checked={flowPaymentFirst}
                                        onChange={() => setFlowPaymentFirst(!flowPaymentFirst)}
                                        onColor="#bfbdc7"
                                        onHandleColor="#422f90"
                                        handleDiameter={20}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={28}
                                        width={55}
                                        className="react-switch"
                                        id="material-switch"
                                    />
                                </Form.Group>
                                <div style={{ height: 20 }} />
                                <div style={{}}>
                                    <Button style={{ background: COLOR_APP, color: "#ffff", width: "100%" }} onClick={_saveSetting}
                                        disabled={loadingCreateSetting || loadingUpdateSetting} >
                                        {loadingCreateSetting || loadingUpdateSetting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
                                    </Button>
                                </div>
                            </div>
                            <div className="col-6">
                                <h7>ຄໍາແນະນໍາການຕັ້ງຄ່າ</h7>
                                <p style={{ margin: 0, fontSize: 14, }}>-ຖ້າຫາກຕັ້ງຄ່ານີ້ເປີດ: ສຳລັບ ເຊວເພສ  ຈະເປັນລາຍລະອຽດການສັ່ງອໍເດີ ທີ່ຕ້ອງໄດ້ຈ່າຍເງີນກ່ອນການ ກ໊ອກຂໍ້ມູນສ່ວນຕົວ</p>
                                <p style={{ margin: 0, fontSize: 14, }}>-ຖ້າຫາກຕັ້ງຄ່ານີ້ປີດ: ສຳລັບ ເຊວເພສ  ຈະເປັນລາຍລະອຽດການສັ່ງອໍເດີ ທີ່ຕ້ອງໄດ້ກ້ອກຂໍ້ມູນສ່ວນຕົວ ໃຫ້ຄົບກ່ອນການຊຳລະເງີນ</p>
                            </div>
                        </div>
                        <div style={{ height: 20 }} />
                    </div>
                    {/* // TODO Setting Auto Reply Order Confirm */}
                    <div style={{ padding: 20, paddingBottom: 0, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
                        <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> ຕັ້ງຄ່າການ ລະຫັດສີ້ນຄ້າ ທີ່ບໍ່ຂື້ນຕົ້ນດ້ວຍ 0 <span role="img" aria-label="auto-receive">⌨️⌨️</span></h5>
                        <div className="row">
                            <div className="col-6">
                                
                                <Form.Group style={{ display: "flex", flexDirection: 'column' }}>
                                    <h7 style={{ fontWeight: 'bold' }}>ໃຊ້ງານ: <span style={{ fontWeight: 'normal', color: sCodeStartWithO ? "green" : "red" }}>{sCodeStartWithO ? "ເປີດ" : "ປີດ"}</span></h7>
                                    <ReactSwitch
                                        checked={sCodeStartWithO}
                                        onChange={() => setSCodeStartWithO(!sCodeStartWithO)}
                                        onColor="#bfbdc7"
                                        onHandleColor="#422f90"
                                        handleDiameter={20}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={28}
                                        width={55}
                                        className="react-switch"
                                        id="material-switch"
                                    />
                                </Form.Group>
                                <div style={{ height: 20 }} />
                                <div style={{}}>
                                    <Button style={{ background: COLOR_APP, color: "#ffff", width: "100%" }} onClick={_saveSetting}
                                        disabled={loadingCreateSetting || loadingUpdateSetting} >
                                        {loadingCreateSetting || loadingUpdateSetting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
                                    </Button>
                                </div>
                            </div>
                            <div className="col-6">
                                <h7>ຄໍາແນະນໍາການຕັ້ງຄ່າ</h7>
                                <p style={{ margin: 0, fontSize: 14, }}>-ຖ້າຫາກຕັ້ງຄ່ານີ້ເປີດ: ການສ້າງ ລະຫັດສີ້ນຄ້າ ທີ່ບໍ່ຂື້ນຕົ້ນດ້ວຍ 0 ຈະເຮັດວຽກທັນທີ່</p>
                                <p style={{ margin: 0, fontSize: 14, }}>-ຖ້າຫາກຕັ້ງຄ່ານີ້ປີດ: ການສ້າງລະຫັດສີ້ນຄ້າຈະຂື້ນຕົ້ນດ້ວຍ 0 ໃຫ້ໂດຍອັດຕະໂນມັດ</p>
                            </div>
                        </div>
                        <div style={{ height: 20 }} />
                    </div>

                    {/* // TODO Setting Auto Reply Order Confirm */}
                    <div style={{ padding: 20, paddingBottom: 0, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
                        <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> ຕັ້ງຄ່າ ເກັບປາຍທາງ ສຳລັບ ເຊວເພສ<span role="img" aria-label="auto-receive">⌨️⌨️</span></h5>
                        <div className="row">
                            <div className="col-6">
                                
                                <Form.Group style={{ display: "flex", flexDirection: 'column' }}>
                                    <h7 style={{ fontWeight: 'bold' }}>ໃຊ້ງານ: <span style={{ fontWeight: 'normal', color: sp_cod ? "green" : "red" }}>{sp_cod ? "ເປີດ" : "ປີດ"}</span></h7>
                                    <ReactSwitch
                                        checked={sp_cod}
                                        onChange={() => setSp_cod(!sp_cod)}
                                        onColor="#bfbdc7"
                                        onHandleColor="#422f90"
                                        handleDiameter={20}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={28}
                                        width={55}
                                        className="react-switch"
                                        id="material-switch"
                                    />
                                </Form.Group>
                                <div style={{ height: 20 }} />
                                <div style={{}}>
                                    <Button style={{ background: COLOR_APP, color: "#ffff", width: "100%" }} onClick={_saveSetting}
                                        disabled={loadingCreateSetting || loadingUpdateSetting} >
                                        {loadingCreateSetting || loadingUpdateSetting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
                                    </Button>
                                </div>
                            </div>
                            <div className="col-6">
                                <h7>ຄໍາແນະນໍາການຕັ້ງຄ່າ</h7>
                                <p style={{ margin: 0, fontSize: 14, }}>-ຖ້າຫາກຕັ້ງຄ່ານີ້ເປີດ:ຈະເປັນການເປີດການເກັບເງິນປາຍທາງ ຂອງເຊວເພສ</p>
                                <p style={{ margin: 0, fontSize: 14, }}>-ຖ້າຫາກຕັ້ງຄ່ານີ້ປີດ: ຈະເປັນການປິດການເກັບເງິນປາຍທາງ</p>
                            </div>
                        </div>
                        <div style={{ height: 20 }} />
                    </div>
                </>
            )}
        </div>
    );
}

export default SettingOther;